import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { MdLink, MdStar, MdChat, MdDevices, MdPictureAsPdf } from 'react-icons/md';
import { FiDollarSign, FiSearch, FiCreditCard } from 'react-icons/fi';
import { slide as Menu } from 'react-burger-menu';
import smoothscroll from 'smoothscroll-polyfill';
import { HashLink as MenuLink } from 'react-router-hash-link';
import './AboutTemplate.scss';

type Props = {
  name: string,
  email: string,
  subject: string,
  comments: string,
  isEmailValid: boolean,
  onChangeSubject: Function,
  onChangeName: Function,
  onChangeEmail: Function,
  onChangeComments: Function,
  validateEmail: Function,
};

const AboutTemplate = (props: Props) => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    // variableWidth: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const membersInfo = [
    ['최영진', 'CEO / Founder', 'YoungjinChoi.png'],
    ['이우식', 'Sales', 'William_Lee2.jpg'],
  ];

  const membersBox = membersInfo.map((info, index) => (
    <div className="member-box" key={info[0]}>
      <div className="member-img">
        <img src={`${process.env.IMAGES_URL}/images/about/${info[2]}`} alt="sample-img" />
      </div>
      <div className="member-desc">
        <div className="name">{info[0]}</div>
        <p className="duty">{info[1]}</p>
      </div>
    </div>
  ));

  // 비디오 모달
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  // 버거 메뉴 열고 닫기 용
  const [burgerIsOpen, setBurgerIsOpen] = useState(false);

  const handleBurgerState = state => {
    setBurgerIsOpen(state.isOpen);
  };

  const closeBurgerMenu = () => {
    setBurgerIsOpen(false);
  };

  const controlHeaderByScroll = () => {
    if (!document.body) return 0;
    const scrollTop = document.documentElement
      ? document.documentElement.scrollTop || document.body.scrollTop
      : document.body.scrollTop;

    const header = document.getElementById('header');

    if (scrollTop > 100) {
      header.classList.add('darkheader');
    } else if (header.classList[0]) header.classList.remove('darkheader');

    return scrollTop;
  };

  const controlMenusByScroll = () => {
    const { scrollY, innerHeight } = window;
    const { scrollHeight } = document.getElementById('outer-container');
    const targetElements = document.getElementsByClassName('target');
    const scrollTop = document.documentElement
      ? document.documentElement.scrollTop || document.body.scrollTop
      : document.body.scrollTop;

    Array.from(targetElements).forEach((el, i) => {
      if (el.offsetTop - scrollTop <= 100) {
        const targetId = el.id;
        const actives = document.querySelectorAll('.active');

        Array.from(actives).forEach(a => {
          a.classList.remove('active');
        });

        const targetMenus = document.querySelectorAll(`a[href='/about#${targetId}']`);

        Array.from(targetMenus).forEach(a => {
          a.classList.add('active');
        });
      } else if (scrollY + innerHeight >= scrollHeight) {
        // 스크롤이 스크린 최하단에 도달하면 '문의하기' 메뉴 활성화되도록 처리
        if (i === 6) {
          const actives = document.querySelectorAll('.active');

          Array.from(actives).forEach(a => {
            a.classList.remove('active');
          });

          const targetMenus = document.querySelectorAll(`a[href='/about#section7']`);

          Array.from(targetMenus).forEach(a => {
            a.classList.add('active');
          });
        }
      }
    });
  };

  const smoothScrolling = el => {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      // 해당 요소와 페이지 최상단 사이의 거리에서 80(섹션 타이틀 상단 마진값)을 빼 각 섹션 상단라인과 맞물리도록 스크롤
      top: el.offsetTop - 64,
    });
  };

  useEffect(() => {
    if (document && document.body && document.body.scrollTop) {
      document.body.scrollTop = 0;
    }
    if (document && document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    smoothscroll.polyfill();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', controlMenusByScroll);
    window.addEventListener('resize', controlMenusByScroll);
    window.addEventListener('scroll', controlHeaderByScroll);
    return () => {
      window.removeEventListener('scroll', controlHeaderByScroll);
      window.removeEventListener('scroll', controlMenusByScroll);
      window.removeEventListener('resize', controlMenusByScroll);
    };
  }, [controlHeaderByScroll, controlMenusByScroll]);

  return (
    <div id="outer-container">
      <Menu
        right
        pageWrapId={'page-wrap'}
        outerContainerId={'outer-container'}
        isOpen={burgerIsOpen}
        onStateChange={state => handleBurgerState(state)}
      >
        <MenuLink
          scroll={el => smoothScrolling(el)}
          className="active"
          to={'/about#section1'}
          onClick={closeBurgerMenu}
        >
          회사소개
        </MenuLink>
        <MenuLink
          scroll={el => smoothScrolling(el)}
          to={'/about#section2'}
          onClick={closeBurgerMenu}
        >
          서비스
        </MenuLink>
        <MenuLink
          scroll={el => smoothScrolling(el)}
          to={'/about#section3'}
          onClick={closeBurgerMenu}
        >
          핵심기능
        </MenuLink>
        <MenuLink
          scroll={el => smoothScrolling(el)}
          to={'/about#section4'}
          onClick={closeBurgerMenu}
        >
          고객후기
        </MenuLink>
        <MenuLink
          scroll={el => smoothScrolling(el)}
          to={'/about#section5'}
          onClick={closeBurgerMenu}
        >
          사람들
        </MenuLink>
        <MenuLink
          to={'/about#section6'}
          scroll={el => smoothScrolling(el)}
          onClick={closeBurgerMenu}
        >
          문의하기
        </MenuLink>
        <MenuLink
          to={'/about#section7'}
          scroll={el => smoothScrolling(el)}
          onClick={closeBurgerMenu}
        >
          연락처
        </MenuLink>
      </Menu>

      <div className={'AboutTemplate'} id="page-wrap">
        <header id="header">
          <div className="row">
            <div className="logo">
              <Link to={'/'}>
                <img
                  src={`${process.env.IMAGES_URL}/logo-light.svg`}
                  className="logo-light"
                  alt="logo"
                />
                <img src={`${process.env.IMAGES_URL}/logo.svg`} className="logo-blue" alt="logo" />
              </Link>
            </div>
            <div className="menus">
              <ul>
                <li>
                  <MenuLink
                    scroll={el => smoothScrolling(el)}
                    className="active"
                    to={'/about#section1'}
                  >
                    회사소개
                  </MenuLink>
                </li>
                <li>
                  <MenuLink scroll={el => smoothScrolling(el)} to={'/about#section2'}>
                    서비스
                  </MenuLink>
                </li>
                <li>
                  <MenuLink scroll={el => smoothScrolling(el)} to={'/about#section3'}>
                    핵심기능
                  </MenuLink>
                </li>
                <li>
                  <MenuLink scroll={el => smoothScrolling(el)} to={'/about#section4'}>
                    고객후기
                  </MenuLink>
                </li>
                <li>
                  <MenuLink scroll={el => smoothScrolling(el)} to={'/about#section5'}>
                    사람들
                  </MenuLink>
                </li>
                <li>
                  <MenuLink scroll={el => smoothScrolling(el)} to={'/about#section6'}>
                    문의하기
                  </MenuLink>
                </li>
                <li>
                  <MenuLink scroll={el => smoothScrolling(el)} to={'/about#section7'}>
                    연락처
                  </MenuLink>
                </li>
              </ul>
            </div>
          </div>
        </header>

        {/* 최상단 소개 이미지 및 영상 */}
        <section className="bg-home target" id="section1">
          <div className="bg-overlay" />
          <div className="home-center">
            <div className="home-desc-center">
              <div className="container">
                <div className="row">
                  <h2 className="home-title">연구에만 집중할 수 있도록</h2>
                  <p className="home-sub-title">
                    우리는 바이오 산업에 IT혁신을 통해 더 나은 연구 환경에 기여합니다.
                    <br />
                    이를 통해 과학자들이 혁신적인 연구에 도움이 될 수 있도록 지원합니다.
                  </p>
                  <div>
                    <div className="getStartedBtn">
                      <Link to={'/'} className="btn">
                        사이트 둘러보기
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 미션 */}
        {/* <section className="customer-review target" id="section4">
          <div className="container">
            <div className="row-title">
              <div className="main-title">
                <span className="bold">미션</span>
              </div>
              <span className="main-title-border">
                <i className="mdi mdi-set-none" />
              </span>
            </div>
            <div className="row-testimonial">
              <div className="testimonial-box">
                <h4>
                  견적 요청 서비스를 통해 편하게 제품 구매가 가능했습니다. 특히 한 번에 다양한
                  견적서를 동시에 받을 수 있어서 제품 비교가 수월했습니다.
                </h4>
              </div>
            </div>
          </div>
        </section> */}

        {/* 데이터씨 서비스 */}
        <section className="core_feature target" id="section2">
          <div className="main-title">
            <span className="bold">데이터씨 서비스</span>
          </div>
          <span className="main-title-border">
            <MdLink />
          </span>
          <div className="wrapper" style={{ marginTop: '3rem' }}>
            <div className="buy_online">
              <div>
                <div className="title">캐시바이</div>
                <div className="features_border" />
                <p className="description">
                  연구제품 전문가들에게 빠른 상담을 통해 궁금한 부분을 해결하세요.
                  <br />
                  견적서와 발주서가 없이도 제품 구매가 가능해요. 원하는 제품을 쉽게 구매하세요.
                </p>
                <Link to={'/'}>
                  더 알아보기
                  <i className="mdi mdi-chevron-right" />
                </Link>
              </div>
            </div>
            <div className="image_container">
              <img
                className="sample-image"
                src={`${process.env.IMAGES_URL}/images/about/cacheby_no.png`}
                alt="img_buy-online"
              />
            </div>
          </div>
          <div className="wrapper" style={{ marginTop: '5rem' }}>
            <div className="image_container2">
              <img
                className="sample-image"
                src={`${process.env.IMAGES_URL}/images/about/labsby_no.png`}
                alt="img_ask-order"
              />
            </div>
            <div className="ask_order">
              <div>
                <div className="title">랩스바이</div>
                <div className="features_border" />
                <p className="description">
                  스프레드 시트, 이메일 및 스티커 메모만으로는 충분하지 않습니다.
                  <br />
                  바이오 연구환경에 최적화된 연구실 관리 플랫폼입니다.
                </p>
                <a href={'https://labsby.com'} target="_blank">
                  더 알아보기
                  <i className="mdi mdi-chevron-right" />
                </a>
              </div>
            </div>
            <div className="image_container3">
              <img
                className="sample-image"
                src={`${process.env.IMAGES_URL}/images/about/labsby_no.png`}
                alt="img_ask-order"
              />
            </div>
          </div>
          <div className="wrapper" style={{ marginTop: '5rem' }}>
            <div className="buy_online">
              <div>
                <div className="title">바이오위클리</div>
                <div className="features_border" />
                <p className="description">
                  매주 바이오 소식만 정리해서 보내 드리는 바이오 주간 뉴스레터
                </p>
                <a href={'https://bioweekly.co.kr'} target="_blank">
                  더 알아보기
                  <i className="mdi mdi-chevron-right" />
                </a>
              </div>
            </div>
            <div className="image_container">
              <img
                className="sample-image"
                src={`${process.env.IMAGES_URL}/images/about/bioweekly_no.png`}
                alt="img_buy-online"
              />
            </div>
          </div>
        </section>

        {/* 서비스 이용하기 */}
        <section className="go_use_cacheby">
          <div className="container">
            <div className="row">
              <div>캐시바이 서비스 이용하기</div>
              <div>
                <Link to={'/'} className="btn">
                  사이트 둘러보기
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* 캐시바이 핵심기능 */}
        <section id="section3" className="services target">
          <div className="container">
            <div className="row-title">
              <div className="main-title">
                <span className="bold">캐시바이 핵심기능</span>
              </div>
              <span className="main-title-border">
                <MdLink />
              </span>
            </div>
            <div className="row-service" style={{ marginTop: '1.5rem' }}>
              <div className="col-service">
                <div className="service-box">
                  <div className="service-icon">
                    <FiDollarSign size="36" />
                  </div>
                  <div className="service-desc">
                    <h4>합리적인 가격</h4>
                    <p>중간유통 없이 가장 경제적인 가격으로 연구제품을 공급합니다.</p>
                  </div>
                </div>
              </div>
              <div className="col-service">
                <div className="service-box">
                  <div className="service-icon">
                    <FiSearch size="36" />
                  </div>
                  <div className="service-desc">
                    <h4>상품 검색</h4>
                    <p className="text-muted mb-0">
                      카테고리 별 검색을 통해 원하시는 바이오 제품들을 한 눈에 보실 수 있어요.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-service">
                <div className="service-box">
                  <div className="service-icon">
                    <MdChat size="36" />
                  </div>
                  <div className="service-desc">
                    <h4>실시간 채팅</h4>
                    <p>제품 별 파트너와 실시간 상담을 통해 제품에 대한 상세내용을 알 수 있어요.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row-service">
              <div className="col-service">
                <div className="service-box">
                  <div className="service-icon">
                    <FiCreditCard size="36" />
                  </div>
                  <div className="service-desc">
                    <h4>연구비 카드 결제</h4>
                    <p>연구비 카드로 결제 하실 수 있어요. MMS, 이메일로 결제 링크를 보내드려요.</p>
                  </div>
                </div>
              </div>
              <div className="col-service">
                <div className="service-box">
                  <div className="service-icon">
                    <MdDevices size="36" />
                  </div>
                  <div className="service-desc">
                    <h4>웹, 모바일 가능</h4>
                    <p>PC뿐만 아니라 휴대폰 환경에서도 모든 기능을 이용할 수 있어요.</p>
                  </div>
                </div>
              </div>
              <div className="col-service">
                <div className="service-box">
                  <div className="service-icon">
                    <MdPictureAsPdf size="36" />
                  </div>
                  <div className="service-desc">
                    <h4>견적서/거래명세서 다운로드</h4>
                    <p>온라인으로 견적서와 거래명세서를 다운로드 할 수 있어요.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 고객후기 */}
        <section className="customer-review target" id="section4">
          <div className="container">
            <div className="row-title">
              <div className="main-title">
                <span className="bold">고객후기</span>
              </div>
              <span className="main-title-border">
                <MdLink />
              </span>
            </div>
            <div className="row-testimonial">
              <div className="testimonial-box">
                <h1>
                  <i className="mdi mdi-format-quote-open" />
                </h1>
                <h4> 다양한 연구제품을 한 곳에서 구매할 수 있어서 편리했습니다.</h4>
                <p className="star">
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                </p>
              </div>
            </div>
            <div className="row-testimonial">
              <div className="testimonial-box">
                <h1>
                  <i className="mdi mdi-format-quote-open" />
                </h1>
                <h4>
                  {' '}
                  빠른 상담을 통해 다양한 연구제품을 한 곳에서 구매할 수 있어서 편리했습니다.
                </h4>
                <p className="star">
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                </p>
              </div>
            </div>
            <div className="row-testimonial">
              <div className="testimonial-box">
                <h1>
                  <i className="mdi mdi-format-quote-open" />
                </h1>
                <h4> 한 주간의 바이오 소식을 주제별로 볼 수 있어 좋습니다.</h4>
                <p className="star">
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                  <MdStar size="18" />
                </p>
              </div>
            </div>
            <div className="row-companies">
              <Slider {...settings}>
                <div className="company-logo">
                  <img src={`${process.env.IMAGES_URL}/images/about/biocs.png`} alt="biocs-logo" />
                </div>
                <div className="company-logo">
                  <img
                    src={`${process.env.IMAGES_URL}/images/about/hyundai_micro_logo.png`}
                    alt="hyundai_micro-logo"
                  />
                </div>
                <div className="company-logo">
                  <img
                    id="charles_river-logo"
                    src={`${process.env.IMAGES_URL}/images/about/charles_river.png`}
                    alt="charles_river-logo"
                  />
                </div>
                <div className="company-logo">
                  <img src={`${process.env.IMAGES_URL}/images/about/bkt.png`} alt="bkt-logo" />
                </div>
                <div className="company-logo">
                  <img
                    src={`${process.env.IMAGES_URL}/images/about/scinote.png`}
                    alt="scinote-logo"
                  />
                </div>
                <div className="company-logo">
                  <img
                    src={`${process.env.IMAGES_URL}/images/about/duksan.png`}
                    alt="duksan-logo"
                  />
                </div>
                <div className="company-logo">
                  <img
                    src={`${process.env.IMAGES_URL}/images/about/mettler_toledo.png`}
                    alt="mettler_toledo-logo"
                  />
                </div>
              </Slider>
            </div>
          </div>
        </section>

        {/* 사람들 */}
        <section className="members target" id="section5">
          <div className="container">
            <div className="row-title">
              <div className="main-title">
                <span className="bold">함께하는 사람들</span>
              </div>
              <span className="main-title-border">
                <MdLink />
              </span>
            </div>
            <div className="row-members">{membersBox}</div>
          </div>
        </section>

        {/* 서비스 이용하기 */}
        <section className="go_use_cacheby">
          <div className="container">
            <div className="row">
              <div>랩스바이 서비스 이용하기</div>
              <div>
                <a href={'https://labsby.com'} target="_blank" className="btn">
                  사이트 둘러보기
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* 문의하기 */}
        <section className="inquiry target" id="section6">
          <div className="container">
            <div className="row-title">
              <div className="main-title">
                <span className="bold">문의하기</span>
              </div>
              <span className="main-title-border">
                <MdLink />
              </span>
            </div>
            <form onSubmit={props.submitForm} className="form">
              <div className="row">
                <div className="form-group name">
                  <label htmlFor="name">
                    이름
                    <input
                      id="name"
                      type="text"
                      value={props.name}
                      className="form-control"
                      placeholder="이름을 입력해주세요."
                      onChange={props.onChangeName}
                      required
                    />
                  </label>
                </div>

                <div className="form-group email">
                  <label htmlFor="email">
                    이메일
                    <input
                      id="email"
                      type="email"
                      value={props.email}
                      className="form-control"
                      placeholder="이메일을 입력해주세요."
                      onChange={props.onChangeEmail}
                      onBlur={() => props.validateEmail(props.email)}
                      required
                    />
                    {!props.isEmailValid && (
                      <div className="email-validation-failed">올바른 이메일 형식이 아닙니다.</div>
                    )}
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="form-group subject">
                  <label htmlFor="subject">
                    제목
                    <input
                      type="text"
                      value={props.subject}
                      className="form-control"
                      id="subject"
                      placeholder="제목을 입력해주세요."
                      onChange={props.onChangeSubject}
                      required
                    />
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="form-group comments">
                  <label htmlFor="comments">
                    내용
                    <textarea
                      value={props.comments}
                      id="comments"
                      rows="4"
                      className="form-control"
                      placeholder="내용을 입력해주세요."
                      onChange={props.onChangeComments}
                      required
                    />
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="submit">
                  <input type="submit" className="submitBtn btn" value="보내기" />
                </div>
              </div>
            </form>
          </div>
        </section>

        <section className="contact target" id="section7">
          <div className="main-title">
            <span className="bold">연락처</span>
          </div>
          <span className="main-title-border">
            <MdLink />
          </span>
          <div className="wrapper">
            <div className="buy_online">
              <div>
                <div className="title">언제든지 연락주세요!</div>
                <div className="features_border" />
                <div>
                  <p className="description">
                    <span>이메일</span> info@datasee.co.kr
                  </p>
                  <p className="description">
                    <span>대표번호</span> 02-585-1342
                  </p>
                  <p className="description">
                    <span>주소</span>
                    <br />
                    서울시 서초구 동광로1길 52, 1층
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="footer">
          <div className="copy-rights">
            Copyright © 2021 <strong>DATASEE</strong> All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTemplate;



// WEBPACK FOOTER //
// ./src/components/about/AboutTemplate/AboutTemplate.js